import React from 'react'
import { useTranslation } from 'react-i18next'
import { useStyles } from './FileUploader.styles'

type Props = {
    types?: string[]
    minSize?: number
    maxSize?: number
}

const DrawTypes: React.FC<Props> = ({ types, minSize, maxSize }: Props) => {
    const styles = useStyles({ error: false })
    const { t } = useTranslation('common')

    const restrictions = []
    if (maxSize) restrictions.push(`${t('fileUploader.size')} <= ${maxSize}`)
    if (minSize) restrictions.push(`${t('fileUploader.size')} >= ${minSize}`)

    const title =
        types && types.length > 0
            ? `${restrictions.join(', ')} ${t(
                  'fileUploader.types'
              )}: ${types.join(', ')}`
            : ''

    return (
        <span title={title} className={styles.fileTypes}>
            {types && types.length > 0 ? types.join(', ') : null}
        </span>
    )
}

export default DrawTypes
